import {SortingOrderEnum} from 'enums';
import {ItemsOrderingEnum} from '../../enums';

export const itemAllOrderingMap = {
  [ItemsOrderingEnum.Name]: {
    [SortingOrderEnum.ASC]: 'Text: A-Z',
    [SortingOrderEnum.DESC]: 'Text: Z-A',
  },
  [ItemsOrderingEnum.Created]: {
    [SortingOrderEnum.ASC]: 'Created: Oldest First',
    [SortingOrderEnum.DESC]: 'Created: Newest First',
  },
};
